import { useMemo } from 'react'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setHistoryView } from 'Pods/ThreeDStudio/Store/actions/ui'
import { HISTORY_VIEW } from 'Pods/ThreeDStudio/Store/constants'

/**
 * The Grid/Tree choice lives in the store so it survives detaching the History window,
 * which remounts the tab. The tree always receives every run so filtered matches keep
 * their ancestors; `visibleIds` marks which of them pass the category filter.
 */
function useHistoryView(treeViewEnabled, isFiltered, filteredVariations) {
  const view = useThreeDStudioStore(state => state.ui.historyView)
  const isTreeView = treeViewEnabled && view === HISTORY_VIEW.TREE

  const visibleIds = useMemo(
    () => (isFiltered ? new Set(filteredVariations.map(({ id }) => String(id))) : null),
    [isFiltered, filteredVariations],
  )

  return { view, isTreeView, visibleIds, setView: setHistoryView }
}

export default useHistoryView
